var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNopocket01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-71{fill:none;}.cls-71,.cls-70,.cls-69{stroke:#010101;stroke-miterlimit:10;}.cls-71,.cls-69{stroke-width:3px;}.cls-70,.cls-69{fill:#fff;}.cls-70{stroke-dasharray:3;}.cls-68{fill:#010101;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M350.87,160.58V358.86a43.73,43.73,0,0,1-43.72,43.72H125.59a43.73,43.73,0,0,1-43.72-43.72V160.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M125.59,399.58a40.77,40.77,0,0,1-40.72-40.72V163.58h263V358.86a40.77,40.77,0,0,1-40.72,40.72Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 81.87,
    y: 108.58,
    width: 269,
    height: 52
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 84.87,
    y: 111.58,
    width: 263,
    height: 46
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 205.68,
    y: 30.57,
    width: 11.66,
    height: 467.15,
    transform: "translate(-126.88 262.74) rotate(-51.08)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: -22.08,
    y: 258.28,
    width: 467.15,
    height: 11.66,
    transform: "translate(-118.98 191.51) rotate(-38.92)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNopocket01);
export default __webpack_public_path__ + "static/media/NO POCKET-01.d66ce7d4391fdfc6b49be95050baa73a.svg";
export { ForwardRef as ReactComponent };